// web/src/store/phone/_consult.ts —— 咨询转 / 忙时邀请动作（从 store 拆出，避免顶满 500 行）
import { Message } from '@arco-design/web-react';
import { setAssistHold } from '../../api/calls';
import { rt } from './_state';
import type { PhoneStore } from './_model';

type Get = () => PhoneStore;
type Set = (p: Partial<PhoneStore>) => void;

export async function inviteExpert(get: Get, set: Set, dest: string, label?: string) {
  const t = (dest || '').trim();
  if (!t) {
    Message.warning('请选择邀请目标');
    return;
  }
  if (get().status !== 'in-call') {
    Message.info('请先接通客户再邀请');
    return;
  }
  if (!rt.zitch) {
    Message.info('咨询转仅在 zitch 引擎下可用；当前请用盲转');
    return;
  }
  if (get().consultPhase || rt.zitch.consultPending()) {
    Message.warning('已有进行中的邀请，请先完成转接或取消');
    return;
  }
  const customerCall = rt.zitch.currentCall();
  if (!customerCall) {
    Message.warning('当前通话号丢失，无法邀请');
    return;
  }
  await rt.zitch.hold(customerCall);
  set({ held: true, consultPhase: 'ringing', consultDest: (label || t).trim() });
  void setAssistHold(true);
  rt.zitch.inviteExpert(t);
}

export async function completeConsultTransfer(_get: Get, set: Set) {
  if (!rt.zitch) return;
  const customerCall = rt.zitch.currentCall();
  const expertCall = rt.zitch.consultCall();
  if (!customerCall || !expertCall) {
    Message.warning('专家尚未接通，无法完成转接');
    return;
  }
  rt.zitch.completeTransfer(customerCall, expertCall);
  set({ transferredOut: true, consultPhase: '', consultDest: '' });
  Message.success('已完成转接');
}

export async function cancelConsult(get: Get, set: Set) {
  if (!rt.zitch) {
    set({ consultPhase: '', consultDest: '', held: false });
    return;
  }
  const customerCall = rt.zitch.currentCall();
  const expertCall = rt.zitch.consultCall();
  rt.zitch.cancelConsult(expertCall, customerCall);
  set({ consultPhase: get().consultPhase ? 'ringing' : '', held: false });
  void setAssistHold(false);
  Message.info('已取消邀请，客户通话已恢复');
}

export function dismissInvite(get: Get, set: Set) {
  const inv = get().invite;
  if (!inv) return;
  rt.zitch?.hangup(inv.call);
  set({ invite: null, inviteTakeover: null });
}

export async function acceptInvite(get: Get, set: Set, mode: 'hold' | 'hangup' | 'answer') {
  const inv = get().invite;
  if (!inv || !rt.zitch) return;
  // 先记下邀请 call+来源：客户腿 ended 可能紧随 hangup 到达；保持并接时客户后挂升主路也靠它回填。
  // 邀请失败/取消走 invite-ended（按 call 号清），不得把错号钉在条上。
  set({
    invite: null,
    inviteTakeover: { call: inv.call, from: inv.from },
    ...(mode === 'answer' ? { remoteNumber: inv.from, direction: 'in' as const } : {}),
  });
  if (mode === 'hold') {
    const customerCall = rt.zitch.currentCall();
    if (customerCall) {
      await rt.zitch.hold(customerCall);
      set({ held: true });
      void setAssistHold(true);
    }
  } else if (mode === 'hangup') {
    const customerCall = rt.zitch.currentCall();
    if (customerCall) await rt.zitch.hangup(customerCall);
  }
  await rt.zitch.answer(inv.call);
}
